import Loadable from 'components/core/Loadable';
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

// Auth
const WarrantySalamanPage = Loadable(lazy(() => import('pages/WarrantySalaman/index')));


const WarrantySalaman: RouteObject = {
  path: 'bao-hanh-san-pham-salaman/:warrantyId',
  element: <WarrantySalamanPage />,
};

export default WarrantySalaman;
